module.exports = __webpack_public_path__ + "static/media/avatars_spritesheet.199ea92d.png";